import React from 'react';

import '../App.css';
import NavBar from '../components/NavBar';

function Properties() {
    return (
        <>

            <div className='h1'>
            <h1>Properties</h1>
            </div>
            <div className='parent'>
                
                <div className="child">
                    <label>
                        Add Property: 
                    </label>
                    <input type="text" placeholder="Street Address*" />
                    <input type="text" placeholder="City*" />
                    <input type="text" placeholder="State*" />
                    <input type="text" placeholder="Zip Code*" />
                    <input type="submit" value="Submit" />
                    <div className='center-note'>
                        <p>* indicates a required field.</p>
                    </div>
                </div>
                <div className="child">
                    <label>
                        Search Properties: 
                    </label>
                    <input type="text" placeholder="Street Address" />
                    <input type="text" placeholder="City" />
                    <input type="text" placeholder="State" />
                    <input type="text" placeholder="Zip Code" />
                    <input type="submit" value="Submit" />
                </div>
            </div>
            <div className='center-paragraph'>
                <p>* Deleting a property will delete all resident manager assignments associated with that property.</p>
            </div>
            <table id="customers" className='center-table'>
                <tr>
                    <th>ID</th>
                    <th>Street Address</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Zip Code</th>
                    <th></th>
                </tr>
                <tr>
                    <td>000001</td>
                    <td>123 Main St.</td>
                    <td>Santa Barbara</td>
                    <td>CA</td>
                    <td>93101</td>
                    <td><button>Edit</button>
                    <button>Delete</button></td>
                </tr>
                <tr>
                    <td>000002</td>
                    <td>455 16th St.</td>
                    <td>Goleta</td>
                    <td>CA</td>
                    <td>93117</td>
                    <td><button>Edit</button>
                    <button>Delete</button></td>
                </tr>
                <tr>
                    <td>000003</td>
                    <td>28765 Palm Ave.</td>
                    <td>Santa Barbara</td>
                    <td>CA</td>
                    <td>93103</td>
                    <td><button>Edit</button>
                    <button>Delete</button></td>
                </tr>
                <tr>
                    <td>000004</td>
                    <td>99 Manzanita Way</td>
                    <td>Goleta</td>
                    <td>CA</td>
                    <td>93117</td>
                    <td><button>Edit</button>
                    <button>Delete</button></td>

                </tr>
            </table>

            <br></br>
            <div>
                <NavBar />
            </div>

        </>
    );
}

export default Properties;